import { useMemo } from 'react'
import { FEATURE_FLAGS } from '@app/app-constants'
import type { IdentifyingInformation } from '@app/domains/layers/types/layers.types'
import { useFeatureFlags } from '@app/hooks/useFeatureFlags'

export function usePotentialIdentifyingInformation(): IdentifyingInformation[] {
  const { useFeatureFlag } = useFeatureFlags()
  const isPopulationEnabled = useFeatureFlag(FEATURE_FLAGS.POPULATION)

  return useMemo(
    () => [
      {
        name: 'Value',
        property: 'replacement_cost',
        suffix: '',
      },
      {
        name: 'Damage Cost',
        property: 'damage_cost',
        suffix: '',
      },
      ...(isPopulationEnabled
        ? [
            {
              name: 'No. Residents',
              property: 'population',
              suffix: ' people',
            },
          ]
        : []),
    ],
    [isPopulationEnabled],
  )
}
